/**
 * Feeds one streamed part to the run store and then to every extension registered for it. The
 * framework's parts reach extensions too, so a host can react to a handoff it also wants drawn.
 */
export function dispatchDataPart(store, extensions, part) {
    store.getState().applyPart(part);
    for (const extension of extensions) {
        if (extension.part === part.type)
            extension.onPart(part.data, { store, part });
    }
}
